(()=>{const b=document.body,p=new URLSearchParams(location.search);window.dataLayer=window.dataLayer||[];const events=[];window.landingEvents=events;function emit(event,extra={}){const e={event,lp_id:b.dataset.page,sku:b.dataset.sku,keyword_id:p.get('keyword_id')||'',ad_group:p.get('ad_group')||'',...extra};events.push(e);window.dataLayer.push(e);try{if(window.Shopify?.analytics?.publish)Promise.resolve(Shopify.analytics.publish('diysoso:'+event,e)).catch(()=>{})}catch(_){}}emit('landing_view');document.querySelectorAll('[data-destination]').forEach(a=>{const url=new URL(a.href);if(a.dataset.destination==='shop'){for(const k of ['gclid','gbraid','wbraid','utm_source','utm_medium','utm_campaign','utm_term','utm_content','keyword_id','ad_group'])if(p.has(k))url.searchParams.set(k,p.get(k));url.searchParams.set('ds_lp',b.dataset.page);a.href=url.toString()}a.addEventListener('click',()=>emit(a.dataset.destination==='shop'?'shop_click':'whatsapp_click',{placement:a.dataset.placement}))});const v = document.querySelector('video');
const bt = document.querySelector('.control');
const mobile = matchMedia('(max-width:700px)').matches;
let userPaused = false;
let playPending = false;
let playRecorded = false;
v.defaultMuted = true;
v.muted = true;
v.autoplay = true;
v.loop = true;
v.playsInline = true;
v.preload = 'auto';
for (const attr of ['muted', 'autoplay', 'loop', 'playsinline', 'webkit-playsinline']) v.setAttribute(attr, '');
v.poster = mobile ? b.dataset.posterMobile : b.dataset.posterDesktop;
const desktopOriginal = {village: 'https://cdn.shopify.com/videos/c/o/v/d236d135948d49c5b840cfdcbea8537a.mp4', santa: 'https://cdn.shopify.com/videos/c/o/v/ed87b633dfe148ef9bc651d47c35a27e.mp4'};
v.src = mobile ? b.dataset.videoMobile : (desktopOriginal[b.dataset.media] || b.dataset.videoDesktop);
function showPlayButton() { bt.textContent = 'Play scene'; }
function play() {
  if (userPaused || document.hidden || playPending || !v.paused) return;
  v.muted = true;
  playPending = true;
  Promise.resolve(v.play()).catch(error => {
    showPlayButton();
    if (error.name !== 'AbortError') emit('autoplay_blocked', {reason: error.name});
  }).finally(() => { playPending = false; });
}
v.addEventListener('playing', () => {
  v.classList.add('ready');
  bt.textContent = 'Pause scene';
  if (!playRecorded) { emit('video_play'); playRecorded = true; }
});
v.addEventListener('error', () => { v.classList.remove('ready'); showPlayButton(); emit('video_error'); });
v.addEventListener('canplay', play);
v.addEventListener('loadeddata', play);
v.addEventListener('ended', play);
bt.onclick = () => {
  if (v.paused) { userPaused = false; play(); }
  else { userPaused = true; v.pause(); showPlayButton(); }
};
document.addEventListener('visibilitychange', () => {
  if (document.hidden) { v.pause(); showPlayButton(); }
  else play();
});
window.addEventListener('pageshow', play);
window.addEventListener('focus', play);
// Retry on a real user gesture if the browser blocks muted autoplay.
document.addEventListener('pointerdown', event => { if (!event.target.closest('.control')) play(); }, {passive:true});
document.addEventListener('touchstart', event => { if (!event.target.closest('.control')) play(); }, {passive:true});
play();
})();
